import { render, staticRenderFns } from "./LessonClassList.vue?vue&type=template&id=042bb254&"
import script from "./LessonClassList.vue?vue&type=script&lang=ts&"
export * from "./LessonClassList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports